import { API_MASTER_DATA } from '../../service/index'
import axios from 'axios'
import firebase from 'firebase/app'
import { Loading } from 'element-ui'
import { BRANCH_WEB_QUEUE_ACCESS_ID , ADD_QUEUE_URL } from '../../service/index'

export default {
  state: {
    flagReciveOrder: null,
    LastOrder: null,
    QRDetail: null,
    OrderHistory: [],
    OrderUpcoming: [],
    BadgeEditOrder: 0
  },
  mutations: {
    setflagReciveOrder (state, payload) {
      state.flagReciveOrder = payload
    },
    setLastOrder (state, payload) {
      state.LastOrder = payload
    },
    setQRDetail (state, payload) {
      state.QRDetail = payload
    },
    setOrderHistory (state, payload) {
      state.OrderHistory = payload
    },
    setOrderUpcoming (state, payload) {
      state.OrderUpcoming = payload
    },
    setBadgeEditOrder (state, payload) {
      state.BadgeEditOrder = payload
    }
  },
  actions: {
    setDelivery ({commit}, DeliveryType) {
      const branchUUID = JSON.parse(localStorage.getItem('branch')).uuid
      if (DeliveryType !== null) {
        if (branchUUID === null) {
          localStorage.setItem('send-' + branchUUID, JSON.stringify(DeliveryType))
        } else {
          localStorage.setItem('send-' + branchUUID, JSON.stringify(DeliveryType))
        }
      }
      commit('setflagReciveOrder', DeliveryType)
    },
    sendOrderList ({commit, dispatch}, payload) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          axios({
            method: 'POST',
            url: API_MASTER_DATA + 'restaurants/' + payload.restaurants + '/branches/' + payload.branches + '/orders',
            headers: { Authorization: idToken },
            data: payload.order
          }).then((response) => {
              // console.log(response)
            if (response.data.meta.status === 200) {
              let BRANCH_ACCESS_ID = Object.values(BRANCH_WEB_QUEUE_ACCESS_ID)
              // console.log(BRANCH_ACCESS_ID)
              // console.log(response.data.data.branch_id)
              // console.log(BRANCH_ACCESS_ID.includes(response.data.data.branch_id))
              if(BRANCH_ACCESS_ID.includes(response.data.data.branch_id)){
                axios({
                  method: 'POST',
                  url: `${ADD_QUEUE_URL}/${response.data.data.branch_id}/add-queue`,
                  data: {
                      unique_order_code : response.data.data.deliveryId,
                      queue_name : payload.order.customer.name
                  }
                })
              }
              resolve({
                data: {
                  status: true,
                  paymentType: response.data.data.paymentType,
                  receiptNo: response.data.data.receiptNo,
                  uniqueOrderCode: response.data.data.uniqueOrderCode,
                  orderId: response.data.data.id
                }
              })
            } else {
              if (response.data.meta.status == 400 && response.data.meta.responseCode == 'P07') {
                resolve({
                  data: {
                    status: false,
                    paymentType: 18,
                    receiptNo: null,
                    uniqueOrderCode: null,
                    orderId: null
                  }
                })
              } else {
                resolve({
                  data: {
                    status: false,
                    paymentType: null,
                    receiptNo: null,
                    uniqueOrderCode: null,
                    orderId: null
                  }
                })
              }
            }
          }).catch((err) => {
            resolve({
              data: {
                status: false,
                paymentType: null,
                receiptNo: null,
                uniqueOrderCode: null,
                orderId: null
              }
            })
          })
        })
      })
    },
    getQRCode ({commit}, payload) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          let restaurant = JSON.parse(localStorage.getItem('restaurant'))
          axios({
            method: 'POST',
            url: API_MASTER_DATA + 'restaurants/' + restaurant.uuid + '/branches/' + payload.uid + '/qrcode',
            headers: { Authorization: idToken },
            data: {
              orderCode: payload.rcp,
              uniqueOrderCode: payload.unq
            }
          }).then((response) => {
            if (response.data.meta.status === 200) {
              commit('setQRDetail', response.data.data)
              resolve(true)
            } else {
              resolve(false)
            }
          }).catch((err) => {
            resolve(false)
          })
        })
      })
    },
    recheckQRPayment ({commit}, payload) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          let restaurant = JSON.parse(localStorage.getItem('restaurant'))
          axios({
            method: 'POST',
            url: API_MASTER_DATA + 'restaurants/' + restaurant.uuid + '/branches/' + payload.uid + '/inquire',
            headers: { Authorization: idToken },
            data: {
              orderCode: payload.rcp,
              uniqueOrderCode: payload.unq
            }
          }).then((response) => {
            if (response.data.meta.status === 200) {
              if (response.data.data.isPaid) {
                resolve(true)
              } else {
                resolve(false)
              }
            } else {
              resolve(false)
            }
          }).catch((err) => {
            resolve(false)
          })
        })
      })
    },
    getDeliveryTime ({commit}, payload) {
      return axios({
        method: 'GET',
        url: API_MASTER_DATA + 'branches/' +  payload.branches + '/delivery-time'
      }).then((response) => {
        if (response.data.meta.status === 200) {
          return response.data.data
        } else if (response.data.meta.status === 404 && response.data.meta.responseCode === 'B14') {
          return response.data.data
        } else {
          return false
        }
      }).catch((err) => {
        return false
      })
    },
    getLastOrder ({commit, dispatch}, payload) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          const branchUUID = JSON.parse(localStorage.getItem('branch')).uuid
          const restaurantUUID = JSON.parse(localStorage.getItem('restaurant')).uuid
          axios({
            method: 'GET',
            url: API_MASTER_DATA + 'restaurants/' + restaurantUUID + '/branches/' + branchUUID + '/orders/' + payload.oid,
            headers: { Authorization: idToken }
          }).then((response) => {
            let loadinginstance = Loading.service({ fullscreen: true, lock: true })
            loadinginstance.close()
            if (response.data.meta.status === 200) {
              if (response.data.data.length === 0) {
                resolve(false)
              } else {
                commit('setLastOrder', response.data.data[0])
                resolve(response.data.data[0])
              }
            } else {
              resolve(false)
            }
          }).catch((err) => {
            let loadinginstance = Loading.service({ fullscreen: true, lock: true })
            loadinginstance.close()
            resolve(false)
          })
        })
      })
    },
    getOrderHistory ({commit}, payload) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          const branchUUID = JSON.parse(localStorage.getItem('branch')).uuid
          const restaurantUUID = JSON.parse(localStorage.getItem('restaurant')).uuid
          axios({
            method: 'GET',
            url: API_MASTER_DATA + 'restaurants/' + restaurantUUID + '/branches/' + branchUUID + '/history-orders?offset=' + payload.paginate,
            headers: { Authorization: idToken }
          }).then((response) => {
            if (response.data.meta.status === 200) {
              commit('setOrderHistory', response.data.data)
              if (payload.paginate > 25) {
                let loadinginstance = Loading.service({ fullscreen: true, lock: true })
                loadinginstance.close()
              }
            } else {
              resolve(false)
            }
          }).catch((err) => {
            resolve(false)
          })
        })
      })
    },
    getOrderUpcoming ({commit}, payload) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          const branchUUID = JSON.parse(localStorage.getItem('branch')).uuid
          const restaurantUUID = JSON.parse(localStorage.getItem('restaurant')).uuid
          axios({
            method: 'GET',
            url: API_MASTER_DATA + 'restaurants/' + restaurantUUID + '/branches/' + branchUUID + '/upcomming-orders?offset=' + payload.paginate,
            headers: { Authorization: idToken }
          }).then((response) => {
            if (response.data.meta.status === 200) {
              commit('setOrderUpcoming', response.data.data)
              if (payload.paginate > 25) {
                let loadinginstance = Loading.service({ fullscreen: true, lock: true })
                loadinginstance.close()
              }
              resolve(true)
            } else {
              resolve(false)
            }
          }).catch((err) => {
            resolve(false)
          })
        })
      })
    },
    getBadgeEditOrder ({commit}, payload) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          axios({
            method: 'GET',
            url: API_MASTER_DATA + 'restaurants/' + payload.restaurant_uuid + '/branches/' + payload.branch_uuid + '/edit-order',
            headers: { Authorization: idToken }
          }).then((response) => {
            if (response.data.meta.status === 200) {
              commit('setBadgeEditOrder', response.data.data.orderCount)
            } else {
              commit('setBadgeEditOrder', 0)
            }
          }).catch(() => {
            commit('setBadgeEditOrder', 0)
          })
        })
      })
    },
    setConfirmEditOrder ({commit}, payload) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          axios({
            method: 'POST',
            url: API_MASTER_DATA + 'restaurants/' + payload.restaurant_uuid + '/branches/' + payload.branch_uuid + '/orders/' + payload.orderId,
          }).then((response) => {
            if (response.data.meta.status === 200) {
              resolve(true)
            } else {
              resolve(false)
            }
          }).catch(() => {
            resolve(false)
          })
        })
      })
    },
    setConfirmUploadSlip ({commit}, payload) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          axios({
            method: 'POST',
            url: API_MASTER_DATA + 'upload/slip/orders/' + payload.orderId,
            headers: {'Content-Type': 'multipart/form-data'},
            data: payload.data
          }).then((response) => {
            if (response.data.meta.status === 200) {
              resolve(true)
            } else {
              resolve(false)
            }
          }).catch((error) => {
            resolve(false)
          })
        })
      })
    }
  },
  getters: {
    flagReciveOrder (state) {
      return state.flagReciveOrder
    },
    LastOrder (state) {
      return state.LastOrder
    },
    QRDetail (state) {
      return state.QRDetail
    },
    OrderHistory (state) {
      return state.OrderHistory
    },
    OrderUpcoming (state) {
      return state.OrderUpcoming
    },
    BadgeEditOrder (state) {
      return state.BadgeEditOrder
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/order/index.js